module.exports = __webpack_public_path__ + "media/icon/icon-map-pin-73fd12ce.svg";